"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			position="top-right"
			duration={5000} // Auto-dismiss after 5 seconds
			closeButton
			expand={true}
			visibleToasts={3} // Max 3 toasts visible at once
			richColors={true}
			gap={8} // Space between toasts to prevent overlap
			toastOptions={{
				style: {
					background: "oklch(var(--background))",
					color: "oklch(var(--foreground))",
					border: "1px solid oklch(var(--border))",
				},
				classNames: {
					error: "border-error bg-error/10 text-error-foreground",
					success: "border-success bg-success/10 text-success-foreground",
					warning: "border-warning bg-warning/10 text-warning-foreground",
					info: "border-primary bg-primary/10 text-primary-foreground",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
